import { render, staticRenderFns } from "./IdentificationAdditionalDocuments.vue?vue&type=template&id=e44567c0"
import script from "./IdentificationAdditionalDocuments.vue?vue&type=script&lang=js"
export * from "./IdentificationAdditionalDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports